import { render, staticRenderFns } from "./dataDownload.vue?vue&type=template&id=0a58534b&scoped=true"
import script from "./dataDownload.vue?vue&type=script&lang=js"
export * from "./dataDownload.vue?vue&type=script&lang=js"
import style0 from "./dataDownload.vue?vue&type=style&index=0&id=0a58534b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58534b",
  null
  
)

export default component.exports